import { useState } from 'react';
import { API_URL } from '../config/api';
import './Downloads.css';

const Downloads = () => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verified, setVerified] = useState(false);
  const [apps, setApps] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (pin.length !== 4) return;

    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/public/apk-download/verify?pin=${pin}`);
      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Pin hatalı.');
        setLoading(false);
        return;
      }

      setApps(data.apps || []);
      setVerified(true);
    } catch (err) {
      setError('Sunucuya bağlanılamadı. Lütfen tekrar deneyiniz.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="downloads-page">
      <div className="downloads-card">
        <div className="downloads-logo-container">
          <img src="/logo.png" alt="Akik Gümüş" className="downloads-logo" />
        </div>

        {!verified ? (
          <>
            <h1>Uygulama İndir</h1>
            <p>Devam etmek için pin kodunu giriniz.</p>

            <form onSubmit={handleSubmit} className="downloads-form">
              {error && (
                <div className="downloads-error">
                  <span className="downloads-error-icon">!</span>
                  {error}
                </div>
              )}

              <input
                type="password"
                inputMode="numeric"
                pattern="\d{4}"
                placeholder="••••"
                value={pin}
                onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
                maxLength={4}
                autoFocus
              />

              <button
                type="submit"
                className={`downloads-submit-btn ${loading ? 'loading' : ''}`}
                disabled={loading || pin.length !== 4}
              >
                {loading ? 'Kontrol ediliyor...' : 'Devam Et'}
              </button>
            </form>
          </>
        ) : (
          <>
            <h1>Uygulamalar</h1>
            <p>İndirmek istediğiniz uygulamayı seçiniz.</p>

            {apps.map((app) => (
              <a
                key={app.id}
                href={`${API_URL}/public/apk-download/file?pin=${pin}&app=${app.id}`}
                className="downloads-submit-btn downloads-download-link"
                style={{ marginBottom: '10px' }}
              >
                {app.label}
              </a>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Downloads;
